import {AxiosPromise} from 'axios';

import {QUOTE_ITEM} from 'constants/actions';
import {ActionType} from '@typescript/common/actionTypes';
import {getSavedHtoItems, isQuickCheckoutInitialized} from 'libs/quickCheckout/quickCheckout';
import {instanceGusaBackend} from 'libs/api';
import {ENDPOINTS} from 'constants/endpoints';

/**
 * Get data for cart
 * @param {Array<string> | null} ids - array with ids
 * @param {{isCheckoutLogin: boolean}} options - settings for getQuote (isCheckoutLogin - flag if it is after checkout login)
 * @return {ActionType<AxiosPromise>} Action
 */
export function getQuoteItems(
    ids: Array<string> | null = null,
    options: {isCheckoutLogin?: boolean} = {},
): ActionType<AxiosPromise> {
    const params: {version?: string; itemIds?: Array<string>; checkout_page?: '1'} = {};
    if (ids !== null) params.itemIds = ids.length ? ids : [''];
    if (isQuickCheckoutInitialized()) params.itemIds = getSavedHtoItems();
    if (options.isCheckoutLogin) params.checkout_page = '1';

    params.version = 'v2.0';

    return {
        type: QUOTE_ITEM.GET_ITEMS,
        payload: instanceGusaBackend({
            method: 'get',
            url: ENDPOINTS.CART_GET_QUOTE,
            params,
        }),
    };
}
